<template>
  <div>
    <v-list-item @click.stop="onDialog" link v-if="!hideTitleForm">
      <v-list-item-title>連盟見合</v-list-item-title>
    </v-list-item>
    <v-dialog v-model="dialogForm" persistent max-width="800px">
      <v-card>
        <v-form ref="form">
          <v-card-title>連盟見合</v-card-title>
          <v-card-text class="container grid-list-md body-content-dialog">
            <v-layout wrap>
              <!-- shift -->
              <v-flex xs6>
                <v-select v-model="dataConnectArrangement.option.shift" :items="shifts" :rules="rules.shift"
                  item-text="label" item-value="value" label="ｼﾌﾄ" @change="openDialogCV"
                  :readonly="dataConnectArrangement.option.shift == 1"></v-select>
              </v-flex>
              <!-- kind -->
              <v-flex xs6>
                <v-select v-model="dataConnectArrangement.connect_flag" :items="CUSTOMER.CONNECT_FLAG.LIST" 
                  item-text="text" item-value="value" label="取組区分" :rules="rules.connect_flag">
                </v-select>
              </v-flex>
              <v-flex xs6 class="d-flex align-center">
                <v-checkbox v-model="dataConnectArrangement.is_online" label="オンライン"></v-checkbox>
              </v-flex>
              <template v-if="dataConnectArrangement.status == statusPlan">
                <v-flex xs6>
                  <v-select v-model="dataConnectArrangement.status" :items="status" :rules="rules.status" item-text="text"
                    item-value="value" label="状態"></v-select>
                </v-flex>
                <v-flex xs6 class="d-flex align-center">
                  <v-checkbox v-model="dataConnectArrangement.option.verTel" label="日時確認済"></v-checkbox>
                </v-flex>
                <v-flex xs3 class="d-flex align-center">
                  <v-checkbox v-model="dataConnectArrangement.option.isPay" label="入金確認済"></v-checkbox>
                </v-flex>
                <v-flex xs3 v-if="dataConnectArrangement.option.isPay">
                  <v-text-field value="0" label="入金額" v-model="dataConnectArrangement.option.payVal">
                  </v-text-field>
                </v-flex>
                <v-flex xs6 v-if="dataConnectArrangement.option.isPay"></v-flex>
                <v-flex xs9 v-else></v-flex>
              </template>
              <template v-else-if="dataConnectArrangement.status == statusImplementation">
                <v-flex xs3>
                  <v-select v-model="dataConnectArrangement.status" :items="status" :rules="rules.status" item-text="text"
                    item-value="value" label="状態"></v-select>
                </v-flex>
                <v-flex xs3>
                  <v-select :items="result" item-text="label" item-value="value" label="結果"
                    v-model="dataConnectArrangement.option.result"></v-select>
                </v-flex>
                <v-flex xs3 class="d-flex align-center">
                  <v-checkbox v-model="dataConnectArrangement.option.follTel" label="フォローTEL済"></v-checkbox>
                </v-flex>
                <v-flex xs3 class="d-flex align-center">
                  <v-checkbox v-model="dataConnectArrangement.option.resTel" label="結果報告TEL済"></v-checkbox>
                </v-flex>
                <v-flex xs3 class="d-flex align-center">
                  <v-checkbox v-model="dataConnectArrangement.option.isPay" label="入金確認済"></v-checkbox>
                </v-flex>
                <v-flex xs3 v-if="dataConnectArrangement.option.isPay">
                  <v-text-field value="0" label="入金額" v-model="dataConnectArrangement.option.payVal">
                  </v-text-field>
                </v-flex>
                <v-flex xs6 v-if="dataConnectArrangement.option.isPay"></v-flex>
                <v-flex xs9 v-else></v-flex>
                <v-flex xs12 v-if="dataConnectArrangement.option.result != null">
                  <template>
                    <div>

                    </div>
                  </template>
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs6>
                  <v-select v-model="dataConnectArrangement.status" :items="status" :rules="rules.status" item-text="text"
                    item-value="value" label="状態"></v-select>
                </v-flex>
              </template>
              <v-flex xs6>
                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateFormatted" :rules="rules.target_date" readonly label="日付"
                      append-icon="mdi-calendar" persistent-hint v-bind="attrs" v-on="on" width="120px">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dataConnectArrangement.target_date"
                    :day-format="(target_date) => new Date(target_date).getDate()" no-title></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-select v-model="dataConnectArrangement.counselor_id"
                  :items="customer && customer.shop_id !== null ? validCounselors : counselors"
                  :rules="rules.counselor"
                  item-text="name" item-value="id" label="担当者" @change="onCounselorSelected">
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item v-on="on" v-bind="attrs" :class="{'d-none': !(item.resignation_date == null || moment(item.resignation_date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD'))}">
                        <v-list-item-title>
                          {{ item.name }}
                        </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-select>
              </v-flex>
              <!-- start_at -->
              <v-flex xs6>
                <v-dialog ref="dialog1" v-model="timePick['target_time']"
                  :return-value.sync="dataConnectArrangement.target_time" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dataConnectArrangement.target_time" :rules="rules.target_time" label="実施時刻"
                      readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="timePick['target_time']" v-model="dataConnectArrangement.target_time" full-width
                    scrollable format="24hr" @change="changeTimeStart($event)">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="timePick['target_time'] = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="saveTimeStart">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <!-- end at -->
              <v-flex xs6>
                <v-dialog ref="dialog2" v-model="timePick['target_time_end']"
                  :return-value.sync="dataConnectArrangement.target_time_end" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dataConnectArrangement.target_time_end" :rules="rules.target_time_end"
                      label="終了時刻" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="timePick['target_time_end']" v-model="dataConnectArrangement.target_time_end"
                    :min="minTime" full-width scrollable format="24hr">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="timePick['target_time_end'] = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.dialog2.save(dataConnectArrangement.target_time_end)">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <!-- phone -->
              <v-flex xs6>
                <v-text-field v-model="phone" :rules="rules.phone" @blur="apiPhone($event)" ref="phone" type=" text"
                  label="携帯番号" :readonly="customerFromHistory">
                </v-text-field>
              </v-flex>
              <!-- name -->
              <v-flex xs6>
                <v-autocomplete v-model="dataConnectArrangement.family_name" :rules="rules.family_name" label="会員名"
                  @keydown="focusCustomerName" @update:search-input="debounce" @input="inputCustomerName"
                  :items="itemFamilyNames" @blur="blurName" :readonly="customerFromHistory"></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field type="text" label="会員№" v-model="dataConnectArrangement.connect_no"
                  :rules="rules.connect_no"> </v-text-field>
              </v-flex>
              <!-- name -->
              <v-flex xs6>
                <v-text-field type="text" label="会員名（連盟表示名）" v-model="dataConnectArrangement.connect_name"
                  :rules="rules.connect_name"> </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field type="text" label="見合地域" v-model="dataConnectArrangement.connect_area"> </v-text-field>
              </v-flex>
              <!-- booth no -->
              <v-flex xs6>
                <v-select v-model="dataConnectArrangement.booth_no_id" :items="validBoothNos"
                  item-text="booth_no" item-value="id" label="ブース№"></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea 
                  label="メモ" 
                  v-model="dataConnectArrangement.note" 
                  :rules="rules.note"
                  :rows="3"
                  @input="onMemoInput"
                  @click="onMemoClick"
                  ref="memoTextarea"
                  class="memo-textarea"
                >
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn width="132" class="info" @click="checkHistory">登録</v-btn>
            <v-btn width="132" class="secondary" @click="closeDialog">戻る</v-btn>
            <v-btn width="132" class="error" v-if="typeSubmit == 'update'" @click="resetForm">削除</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <CompanyVisit :shop_id="shop_id" :date="date" :dialogCV="dialogCV" @closeDialogCV="closeDialogCV" :boothNos="boothNos"
      :counselors="counselors" :hideTitle="true" :valueKindForShift="kindShift" />

    <MemoEditorDialog
      :visible.sync="memoDialog"
      v-model="dataConnectArrangement.note"
      :rules="rules.note"
    />
  </div>
</template>
<script>
import moment from "moment";
import { required, inArray, date, phone, digits, max } from '@/utilities/validation.js';
import CUSTOMER from "@/consts/customer.js";
import constants from '@/consts/constants.js'
import CompanyVisit from "./CompanyVisit.vue";
import store from '@/store'
import Swal from 'sweetalert2';
import MemoEditorDialog from '@/components/common/MemoEditorDialog.vue'

export default {
  name: "ConnectMatchmaking",
  components: { CompanyVisit, MemoEditorDialog },
  props: ['date', 'boothNos', 'counselors', 'shop_id', 'historyData', 'showFormConnectMatching', 'hideTitleForm', 'valueKindForForm', 'customer', 'isLedgerScreen', 'isOnlineShop'],

  data: function () {
    const shifts = CUSTOMER.SHIFTS
    const statusPayments = CUSTOMER.STATUS_PAYMENTS
    const resultTELs = CUSTOMER.RESULT_TELS
    const result = CUSTOMER.RESULT
    const statusPlan = CUSTOMER.STATUS_DEFAULT.getValue('予定')
    const statusImplementation = CUSTOMER.STATUS_DEFAULT.getValue('実施')

    return {
      rules: {
        shift: [
          (v) => required(v),
          (v) => inArray(v, shifts.map(item => item.value)),
        ],
        kind: [
          (v) => required(v),
          (v) => inArray(v, this.kinds.map(item => item.value)),
        ],
        connect_flag: [
          (v) => required(v),
          (v) => inArray(v, CUSTOMER.CONNECT_FLAG.LIST.map(item => item.value)),
        ],
        status: [
          (v) => required(v),
          (v) => inArray(v, this.status.map(item => item.value)),
        ],
        statusPayment: [
          (v) => required(v),
          (v) => inArray(v, statusPayments.map(item => item.value)),
        ],
        resultTEL: [
          (v) => required(v),
          (v) => inArray(v, resultTELs.map(item => item.value)),
        ],
        target_date: [
          (v) => required(v),
          (v) => date(v),
        ],
        counselor: [
          (v) => required(v),
        ],
        target_time: [
          (v) => required(v),
        ],
        target_time_end: [
          (v) => required(v),
        ],
        phone: [
          (v) => required(v),
          (v) => phone(v),
          (v) => digits(v, 13),
        ],
        family_name: [
          (v) => required(v),
        ],
        connect_no: [
          (v) => max(v, 255),
        ],
        connect_name: [
          (v) => max(v, 255),
        ],
        note: [
          (v) => max(v, 1000),
        ],
        result: [
          (v) => required(v),
          (v) => inArray(v, result.map(item => item.value)),
        ]
      },

      dataConnectArrangement: {
        kind: CUSTOMER.EXEC_KIND.NAME.CS_MATCHING,
        status: statusPlan,
        target_date: this.date,
        counselor_id: "",
        target_time: "",
        target_time_end: "",
        internal_customer_id: "",
        note: "",
        type: constants.TYPE_FORM.CONNECT_ARRANGEMENT,
        connect_flag: 2,
        connect_name: "",
        connect_no: "",
        connect_area: "",
        family_name: "",
        family_name_old: "",
        is_online: false,
        option: {
          result: null,
          isPay: false,
          verTel: false,
          follTel: false,
          resTel: false,
          payVal: 0,
          shift: 0,
        },
        booth_no_id: "",
      },
      shifts,
      kinds: CUSTOMER.KINDS.LIST,
      kindName: CUSTOMER.EXEC_KIND.NAME.CS_MATCHING,
      status: CUSTOMER.STATUS_DEFAULT.LIST,
      statusPayments,
      resultTELs,
      timePick: [],
      phone: "",
      phoneOld: "",
      customers: '',
      itemFamilyNames: [],
      isFamilyName: false,
      dialogCV: false,
      dialogForm: false,
      addTimeWithKind: 0,
      typeSubmit: null,
      minTime: null,
      kindShift: 102, //Kind SHIFT_CONTRACT
      timer: null,
      isValueForm: [26],
      customerFromHistory: false,
      statusPlan,
      statusImplementation,
      result,
      validCounselors: [],
      moment: moment,
      validBoothNos: [],
      // memo modal state
      memoDialog: false,
      memoContent: '',
      suppressMemoOpen: false,
      CUSTOMER: CUSTOMER,
    }
  },
  mounted() {
    this.getTimeAddFromKind()
  },
  computed: {
    computedDateFormatted() {
      return this.dataConnectArrangement.target_date ? this.formatDate(this.dataConnectArrangement.target_date) : this.formatDate(this.date)
    },

    computedTimeEndFormatted() {
      return this.dataConnectArrangement.target_date_end ? this.formatDate(this.dataConnectArrangement.target_date_end) : this.formatDate(this.date)
    },
  },
  watch: {
    showFormConnectMatching: function (newDialog) {
      this.dialogForm = newDialog
      this.validCounselors = this.counselors
    },
    phone: function (newPhone) {
      if (newPhone) {
        const phone = newPhone.replace(/\D/g, '')
        const firstBlockPhone = phone.substring(0, 3)
        const secondBlockPhone = phone.substring(3, 7)
        const thirdBlockPhone = phone.substring(7)

        let formatPhone = `${firstBlockPhone}`;
        if (secondBlockPhone.length > 0) {
          formatPhone += `-${secondBlockPhone}`;
        }
        if (thirdBlockPhone.length > 0) {
          formatPhone += `-${thirdBlockPhone}`;
        }
        this.phone = formatPhone;
      }

    },
    historyData: function (newDataHistory) {
      if (newDataHistory.type == constants.TYPE_FORM.CONNECT_ARRANGEMENT && this.valueKindForForm.length == 0) {
        this.dataConnectArrangement.kind = CUSTOMER.EXEC_KIND.NAME.CS_MATCHING
        this.dataConnectArrangement.target_date = this.formatDateSlash(newDataHistory.target_date)
        this.dataConnectArrangement.target_time = newDataHistory.target_time
        this.dataConnectArrangement.target_time_end = newDataHistory.target_time_end
        this.dataConnectArrangement.internal_customer_id = newDataHistory.customer_id
        this.dataConnectArrangement.counselor_id = newDataHistory.counselor_id
        this.dataConnectArrangement.note = newDataHistory.note
        this.phone = newDataHistory.phone
        this.dataConnectArrangement.family_name = newDataHistory.family_name + newDataHistory.given_name
        this.dataConnectArrangement.family_name_old = this.dataConnectArrangement.family_name
        this.itemFamilyNames = [this.dataConnectArrangement.family_name]
        this.dataConnectArrangement.option.connect_area = newDataHistory.option.connect_area
        this.dataConnectArrangement.connect_flag = newDataHistory.connect_flag || CUSTOMER.CONNECT_FLAG.VAL.CONNECT
        this.dataConnectArrangement.option.connect_flag = newDataHistory.option.connect_flag
        this.dataConnectArrangement.option.connect_name = newDataHistory.option.connect_name
        this.dataConnectArrangement.option.connect_no = newDataHistory.option.connect_no
        this.dataConnectArrangement.option.internal_customer_id = newDataHistory.option.internal_customer_id
        this.dataConnectArrangement.option.match_reserve_id = newDataHistory.option.match_reserve_id
        this.dataConnectArrangement.option.shift = newDataHistory.option.shift
        this.dataConnectArrangement.option.result = newDataHistory.option.result
        this.dataConnectArrangement.option.isPay = newDataHistory.option.isPay
        this.dataConnectArrangement.option.verTel = newDataHistory.option.verTel
        this.dataConnectArrangement.option.follTel = newDataHistory.option.follTel
        this.dataConnectArrangement.option.resTel = newDataHistory.option.resTel
        this.dataConnectArrangement.option.payVal = newDataHistory.option.payVal
        this.dataConnectArrangement.status = newDataHistory.status
        this.dataConnectArrangement.connect_no = newDataHistory.connect_no || ''
        this.dataConnectArrangement.connect_name = newDataHistory.connect_name || ''
        this.dataConnectArrangement.connect_area = newDataHistory.connect_area || ''
        this.typeSubmit = 'update'
        this.dataConnectArrangement.booth_no_id = newDataHistory.booth_no_id
        this.dataConnectArrangement.is_online = newDataHistory.is_online == 1
        this.validBoothNos = this.boothNos
      }
    },
    valueKindForForm: function (newValueKindForForm) {

      if (newValueKindForForm) {
        this.family_name = ""
        this.dataConnectArrangement = {
          kind: CUSTOMER.EXEC_KIND.NAME.CS_MATCHING,
          status: this.statusPlan,
          target_date: this.date,
          counselor_id: "",
          target_time: "",
          target_time_end: "",
          internal_customer_id: "",
          note: "",
          type: constants.TYPE_FORM.CONNECT_ARRANGEMENT,
          connect_flag: 2,
          connect_name: "",
          connect_no: "",
          connect_area: "",
          is_online: false,
          option: {
            result: null,
            isPay: false,
            verTel: false,
            follTel: false,
            resTel: false,
            payVal: 0,
            shift: 0,
          },
          booth_no_id: "",
        }
        if (this.customer.id != CUSTOMER.NOT_MEMBER_CUSTOMER && this.customer.id != CUSTOMER.MEMBER_CONNECT) {
          this.customerFromHistory = true
          this.dataConnectArrangement.family_name = this.customer.family_name + this.customer.given_name
          this.itemFamilyNames = [this.customer.family_name + this.customer.given_name]
          this.phone = this.customer.phone_number
        } else {
          this.phone = ''
          this.dataConnectArrangement.family_name = ''
        }
        this.typeSubmit = ''
        this.getTimeAddFromKind()

        if (this.isValueForm.includes(newValueKindForForm)) {
          this.$refs.form.resetValidation()
        }
      }
    },
    date: function (newDate) {
      if (newDate) {
        this.dataConnectArrangement.target_date = newDate
      }
    },
  },
  methods: {
    blurName() {
      this.itemFamilyNames = [this.dataConnectArrangement.family_name_old]
      this.dataConnectArrangement.family_name = this.dataConnectArrangement.family_name_old
      this.isFamilyName = false;
    },
    async debounce(e, timeout = 300) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.searchInputCustomerName(e) }, timeout);
    },
    focusCustomerName() {
      this.isFamilyName = true;
    },
    async searchInputCustomerName(e) {
      if (!this.isFamilyName || e == null || e == '') {
        return
      }

      const url = '/api/v1/customer/by-name/' + e
      const response = await this.$axios.get(url)
      this.customers = response.data.customers
      this.itemFamilyNames = this.customers.map(item => {
        return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
      })
    },
    async inputCustomerName(e) {
      if (e == null) {
        return
      }
      const customers = await this.customers.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')

      if (Object.keys(customers).length > 0) {
        this.itemFamilyNames = await [customers.family_name + customers.given_name]
        this.dataConnectArrangement.family_name = await customers.family_name + customers.given_name
        this.dataConnectArrangement.family_name_old = await customers.family_name + customers.given_name
        this.phone = await customers.phone_number;
        this.phoneOld = await customers.phone_number
        this.dataConnectArrangement.internal_customer_id = await customers.id
        if (this.customer && this.customer.shop_id !== null) {
          this.getCounselorByCustomerShopId(this.dataConnectArrangement.internal_customer_id)
          this.dataConnectArrangement.counselor_id = ''
        }
      }

      this.isFamilyName = false;
    },
    openDialogCV() {
      if (this.dataConnectArrangement.option.shift == 1) {
        this.dialogCV = true
      }
    },
    closeDialogCV() {
      this.dialogCV = false
      this.dataConnectArrangement.option.shift = 0
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
    formatDateSlash(date) {
      if (!date) return null

      const [year, month, day] = date.split('/')
      return `${year}-${month}-${day}`
    },
    checkHistory() {
      const validate = this.$refs.form.validate()
      if (validate == false) {
          return
      }
      
      let dataHistory = this.dataConnectArrangement
      if (this.historyData?.id) {
        dataHistory.id = this.historyData.id
      }
      dataHistory.kind = CUSTOMER.EXEC_KIND.VAL.CS_MATCHING

      this.$axios
        .post("/api/v1/customer/check-history", { dataHistory: dataHistory })
        .then((response) => {
            if (!response.data.canCreate) {
                let  errorMsg = '以下の予定と重複していますが、登録してよろしいですか？';
                if (response.data.conflictingAppointmentRes) {
                  const { kind, targetTime, targetTimeEnd, counselorName, boothNoName, customerName } = response.data.conflictingAppointmentRes;
                  errorMsg += `<p style="font-weight: bold;">${CUSTOMER.EXEC_KIND.getName(kind)}</p>`;
                  errorMsg += `<p>時間：${targetTime.slice(0, -3)}〜${targetTimeEnd.slice(0, -3)}</p>`;
                  errorMsg += `<p>${customerName}</p>`;
                  errorMsg += `<p>担当：${counselorName}</p>`;
                  errorMsg += `<p>ブース：${boothNoName || '--'}</p>`;
                }

                Swal.fire({
                  html: `<div style="text-align: left; color: #000000de; font-size: 14px; font-family: 'Roboto';">${errorMsg}</div>`,
                  confirmButtonText: `<span style="font-size: 14px;">OK</span>`,
                  confirmButtonColor: "#1e88e5",
                  color: '#ffffff',
                  showCancelButton: true,
                  cancelButtonText: `<span style="font-size: 14px;">Cancel</span>`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.submit()
                  }
                });
            } else {
              this.submit()
            }
        })
        .catch((error) => {
            console.log(error);
        });
    },
    submit() {
      const validate = this.$refs.form.validate()
      if (validate == false) {
        return
      }
      this.dataConnectArrangement.kind = CUSTOMER.EXEC_KIND.VAL.CS_MATCHING
      if (this.customerFromHistory) {
        this.dataConnectArrangement.internal_customer_id = this.customer.id
      }

      if (this.dataConnectArrangement.status != this.statusPlan && this.dataConnectArrangement.status != this.statusImplementation) {
        this.dataConnectArrangement.option.result = false
        this.dataConnectArrangement.option.isPay = false
        this.dataConnectArrangement.option.verTel = false
        this.dataConnectArrangement.option.follTel = false
        this.dataConnectArrangement.option.resTel = false
        this.dataConnectArrangement.option.payVal = 0
      }

      if (this.dataConnectArrangement.status != this.statusPlan) {
        this.dataConnectArrangement.option.verTel = false
      }

      if (this.dataConnectArrangement.status != this.statusImplementation) {
        this.dataConnectArrangement.option.result = null
        this.dataConnectArrangement.option.follTel = false
        this.dataConnectArrangement.option.resTel = false
      }

      if (this.dataConnectArrangement.status == this.statusImplementation && this.dataConnectArrangement.option.result == null) {
        this.dataConnectArrangement.option.payVal = 0
        this.dataConnectArrangement.option.isPay = false
      }

      if (this.dataConnectArrangement.status == this.statusImplementation && this.dataConnectArrangement.option.result != null && !this.dataConnectArrangement.option.isPay) {
        this.dataConnectArrangement.option.payVal = 0
      }

      if (this.dataConnectArrangement.booth_no_id === '') {
        this.dataConnectArrangement.booth_no_id = null
      }

      const dataConnectArrangement = this.dataConnectArrangement
      if (this.typeSubmit == 'update') {
        this.$axios
          .put(`/api/v1/customer/${this.dataConnectArrangement.internal_customer_id}/history/${constants.TYPE_FORM.CONNECT_ARRANGEMENT}`, { historyId: this.historyData.id, historyData: dataConnectArrangement })
          .then((response) => {
            this.dialogForm = false
            this.$emit('refreshListHistory')
            this.$emit('closeFormConnectMatching')
            return response;
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      } else {
        this.$axios
          .post("/api/v1/customer/connect-arrangement", { dataConnectArrangement })
          .then((response) => {
            this.dialogForm = false
            this.resetForm()
            this.$emit('refreshCalendar')
            if (this.valueKindForForm) {
              this.$emit('refreshListHistory')
              this.$emit('closeFormConnectMatching')
            }
            if (this.isLedgerScreen) {
              this.$emit('refreshLedgerData')
            }
            return response;
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      }

    },
    getMonth() {
      return moment(this.value).format("MM")
    },
    onDialog() {
      this.$emit('closeMenu')
      this.dialogForm = true
    },
    closeDialog() {
      this.$emit('closeFormConnectMatching')
      this.resetForm()
      this.dialogForm = false
    },
    getTimeAddFromKind() {
      this.$axios
        .get("/api/v1/date-setting/" + CUSTOMER.EXEC_KIND.VAL.CS_MATCHING)
        .then((response) => {
          this.addTimeWithKind = response.data.kind.date_add
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    apiPhone(e) {
      this.isFamilyName = false;
      const currentUserLoginShopId = store.state.user.shop_id
      const validate = this.$refs.phone.validate()
      if (validate == false) {
        this.phoneOld = e.target.value
        this.dataConnectArrangement.family_name = ''
        this.dataConnectArrangement.family_name_old = ''
        this.itemFamilyNames = []
        if (currentUserLoginShopId !== 0 && this.customer && this.customer.shop_id !== null) {
          this.dataConnectArrangement.counselor_id = ''
          this.validCounselors = []
        }
        return
      }
      this.$axios
        .get("/api/v1/customer/phone_number/" + e.target.value)
        .then((response) => {
          const customer = response.data.customer
          if (customer.id != undefined) {
            this.dataConnectArrangement.family_name = customer.family_name + customer.given_name;
            this.dataConnectArrangement.family_name_old = this.dataConnectArrangement.family_name
            this.itemFamilyNames = [this.dataConnectArrangement.family_name]
            this.dataConnectArrangement.internal_customer_id = customer.id
            if (currentUserLoginShopId !== 0 && this.customer && this.customer.shop_id !== null) {
              this.dataConnectArrangement.counselor_id = ''
              this.getCO(customer)
            }
          } else {
            alert('対象者が存在しません')
            this.phone = ''
            this.family_name = ''
            this.itemFamilyNames = []
            if (currentUserLoginShopId !== 0 && this.customer && this.customer.shop_id !== null) {
              this.dataConnectArrangement.counselor_id = ''
              this.validCounselors = []
            }
            return false;
          }

        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    resetForm() {
      this.$refs.form.resetValidation()
      this.kindName = CUSTOMER.EXEC_KIND.NAME.CS_MATCHING
      this.phone = null
      if (this.typeSubmit == 'update' && this.dataConnectArrangement.option.shift == 1) {
        this.dataConnectArrangement = {
          kind: CUSTOMER.EXEC_KIND.NAME.CS_MATCHING,
          status: this.statusPlan,
          target_date: this.date,
          counselor_id: "",
          target_time: "",
          target_time_end: "",
          internal_customer_id: "",
          note: "",
          type: constants.TYPE_FORM.CONNECT_ARRANGEMENT,
          connect_flag: 2,
          connect_name: "",
          connect_no: "",
          connect_area: "",
          family_name: "",
          is_online: false,
          option: {
            result: null,
            isPay: false,
            verTel: false,
            follTel: false,
            resTel: false,
            payVal: 0,
            shift: 1
          },
          booth_no_id: "",
        }
      } else if (this.typeSubmit == 'update') {
        if (this.historyData.type == constants.TYPE_FORM.CONNECT_ARRANGEMENT && this.valueKindForForm.length == 0) {
          this.dataConnectArrangement.kind = CUSTOMER.EXEC_KIND.NAME.CS_MATCHING
          this.dataConnectArrangement.target_date = this.formatDateSlash(this.historyData.target_date)
          this.dataConnectArrangement.target_time = this.historyData.target_time
          this.dataConnectArrangement.target_time_end = this.historyData.target_time_end
          this.dataConnectArrangement.internal_customer_id = this.historyData.customer_id
          this.dataConnectArrangement.counselor_id = this.historyData.counselor_id
          this.dataConnectArrangement.note = this.historyData.note
          this.phone = this.historyData.phone
          this.dataConnectArrangement.family_name = this.historyData.family_name + this.historyData.given_name
          this.itemFamilyNames = [this.dataConnectArrangement.family_name]
          this.dataConnectArrangement.option.connect_area = this.historyData.option.connect_area
          this.dataConnectArrangement.connect_flag = this.historyData.connect_flag || CUSTOMER.CONNECT_FLAG.VAL.CONNECT
          this.dataConnectArrangement.option.connect_flag = this.historyData.option.connect_flag
          this.dataConnectArrangement.option.connect_name = this.historyData.option.connect_name
          this.dataConnectArrangement.option.connect_no = this.historyData.option.connect_no
          this.dataConnectArrangement.option.internal_customer_id = this.historyData.option.internal_customer_id
          this.dataConnectArrangement.option.isPay = this.historyData.option.isPay
          this.dataConnectArrangement.option.match_reserve_id = this.historyData.option.match_reserve_id
          this.dataConnectArrangement.option.shift = this.historyData.option.shift
          this.dataConnectArrangement.option.result = this.historyData.option.result
          this.dataConnectArrangement.option.verTel = this.historyData.option.verTel
          this.dataConnectArrangement.option.follTel = this.historyData.option.follTel
          this.dataConnectArrangement.option.resTel = this.historyData.option.resTel
          this.dataConnectArrangement.option.payVal = this.historyData.option.payVal
          this.dataConnectArrangement.status = this.historyData.status
          this.dataConnectArrangement.connect_no = this.historyData.connect_no || ''
          this.dataConnectArrangement.connect_name = this.historyData.connect_name || ''
          this.dataConnectArrangement.connect_area = this.historyData.connect_area || ''
          this.dataConnectArrangement.booth_no_id = this.historyData.booth_no_id
          this.dataConnectArrangement.is_online = this.historyData.is_online == 1
        }
      } else {
        this.dataConnectArrangement = {
          kind: CUSTOMER.EXEC_KIND.NAME.CS_MATCHING,
          status: this.statusPlan,
          target_date: this.date,
          counselor_id: "",
          target_time: "",
          target_time_end: "",
          internal_customer_id: "",
          note: "",
          type: constants.TYPE_FORM.CONNECT_ARRANGEMENT,
          connect_flag: 2,
          connect_name: "",
          connect_no: "",
          connect_area: "",
          family_name: "",
          is_online: false,
          option: {
            result: null,
            isPay: false,
            verTel: false,
            follTel: false,
            resTel: false,
            payVal: 0,
            shift: 0
          },
          booth_no_id: "",
        }

        if (this.customerFromHistory) {
          this.dataConnectArrangement.family_name = this.customer.family_name + this.customer.given_name
          this.itemFamilyNames = [this.customer.family_name + this.customer.given_name]
          this.phone = this.customer.phone_number
        }
      }
    },
    changeTimeStart(newStartAt) {
      if (newStartAt != "") {
        const startAt = moment(newStartAt, 'HH:mm')
        this.dataConnectArrangement.target_time_end = startAt.isBefore(moment('23:10', 'HH:mm')) ? startAt.add(this.addTimeWithKind, 'minutes').format('HH:mm') : '23:59';
        this.minTime = moment(this.dataConnectArrangement.target_time, 'HH:mm').add(30, 'minutes').format('HH:mm')
      }
    },
    saveTimeStart() {
      this.changeTimeStart(this.dataConnectArrangement.target_time)
      this.$refs.dialog1.save(this.dataConnectArrangement.target_time)
    },
    openMemoModal() {
      if (this.suppressMemoOpen) {
        return;
      }
      this.memoContent = this.dataConnectArrangement.note || '';
      this.memoDialog = true;
      this.$nextTick(() => {
        if (this.$refs.memoTextarea && this.$refs.memoTextarea.$el) {
          const ta = this.$refs.memoTextarea.$el.querySelector('textarea');
          ta && ta.blur();
        }
        if (this.$refs.memoModalTextarea) {
          this.$refs.memoModalTextarea.focus();
        }
        this.adjustMemoModalSize();
      });
    },
    confirmMemoModal() {
      this.dataConnectArrangement.note = this.memoContent;
      this.suppressMemoOpen = true;
      this.memoDialog = false;
      this.$nextTick(() => {
        if (this.$refs.memoTextarea && this.$refs.memoTextarea.$el) {
          const ta = this.$refs.memoTextarea.$el.querySelector('textarea');
          ta && ta.blur();
        }
        setTimeout(() => {
          this.suppressMemoOpen = false;
        }, 200);
      });
    },
    cancelMemoModal() {
      this.suppressMemoOpen = true;
      this.memoDialog = false;
      this.memoContent = this.dataConnectArrangement.note || '';
      this.$nextTick(() => {
        if (this.$refs.memoTextarea && this.$refs.memoTextarea.$el) {
          const ta = this.$refs.memoTextarea.$el.querySelector('textarea');
          ta && ta.blur();
        }
        setTimeout(() => {
          this.suppressMemoOpen = false;
        }, 200);
      });
    },
    adjustMemoModalSize() {
      this.$nextTick(() => {
        const textarea = this.$refs.memoModalTextarea && this.$refs.memoModalTextarea.$el
          ? this.$refs.memoModalTextarea.$el.querySelector('textarea')
          : null;
        if (!textarea) return;

        const MIN_HEIGHT = 120; // px (5 rows * ~24)
        const MAX_HEIGHT = 360; // px (15 rows * ~24)

        textarea.style.height = 'auto';
        const newHeight = Math.max(MIN_HEIGHT, Math.min(textarea.scrollHeight, MAX_HEIGHT));
        textarea.style.height = newHeight + 'px';
      });
    },
    getCO(customer) {
      this.$axios
        .get(`/api/v1/user/counselors?shop_id=${customer.shop_id}`)
        .then((response) => {
          this.validCounselors = response.data.counselors
        })
        .catch((error) => {
          console.log("Error : " + error)
        })
    },
    getCounselorByCustomerShopId(customerId) {
      if (customerId) {
        this.$axios
          .get(`/api/v1/customer/${customerId}`)
          .then((response) => {
            const customer = response.data.customer
            if (customer.id != undefined) {
              this.getCO(customer)
            } else {
              alert('対象者が存在しません')
              this.validCounselors = []
              this.validBoothNos = []
              return false
            }
          })
          .catch((error) => {
            console.log("Error : " + error)
          })
      }
    },
    async onCounselorSelected() {
      const validCounselors = this.customer && this.customer.shop_id !== null ? this.validCounselors : this.counselors
      const counselorSelected = validCounselors.find(counselor => counselor.id === this.dataConnectArrangement.counselor_id)
      await this.$axios.get(`/api/v1/booth_no/shop/${counselorSelected.shop_id}`)
        .then((response) => {
          this.validBoothNos = response.data.booth_nos;
          if (response.data.booth_nos.length > 0 && response.data?.booth_nos[0]?.shop_id != counselorSelected.shop_id) {
            this.dataConnectArrangement.booth_no_id = "";
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    checkMemoContentAndOpenModal(content, maxLines = 3) {
      if (!content || !content.trim()) return;
      
      const explicitLineCount = content.split(/\r?\n/).length;
      
      if (explicitLineCount > maxLines) {
        this.openMemoModal();
        return;
      }
      
      this.$nextTick(() => {
        const textarea = this.$refs.memoTextarea && this.$refs.memoTextarea.$el
          ? this.$refs.memoTextarea.$el.querySelector('textarea')
          : null;
        
        if (textarea) {
          const originalHeight = textarea.style.height;
          textarea.style.height = 'auto';
          
          const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight) || 24;
          const visualLines = Math.ceil(textarea.scrollHeight / lineHeight);
          
          textarea.style.height = originalHeight;
          
          if (visualLines > maxLines) {
            this.openMemoModal();
          }
        }
      });
    },
    onMemoInput(val) {
      const content = typeof val === 'string' ? val : (this.dataConnectArrangement.note || '');
      this.checkMemoContentAndOpenModal(content, 3);
    },
    onMemoClick() {
      const content = this.dataConnectArrangement.note || '';
      this.checkMemoContentAndOpenModal(content, 3);
    },
  }
};
</script>

<style scoped>
.body-content-dialog {
  height: calc(100vh - 210px);
  overflow-y: auto;
}

.container.grid-list-md .layout .flex {
  padding: 4px 12px;
}

/* Clickable textarea styling */
.clickable-textarea {
  cursor: pointer;
}

.memo-modal-textarea ::v-deep .v-text-field__slot textarea {
  min-height: 120px !important;
  max-height: unset !important;
  line-height: 24px !important;
  padding: 12px !important;
  font-size: 14px !important;
  overflow-y: auto !important;
  resize: vertical !important;
}
</style>
  